@if (showCompanyDataOverlay) {
  <div
    class="fixed inset-0 z-[2000] flex items-center justify-center bg-black/50 p-4"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'companyDataRequired.header' | translate"
  >
    <div
      class="w-full max-w-lg rounded-2xl bg-white dark:bg-[var(--color-bunker-500)] shadow-2xl border border-gray-200 dark:border-gray-700"
      (click)="$event.stopPropagation()"
    >
      <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
        <h1 class="text-lg font-semibold text-gray-900 dark:text-gray-100 m-0">
          {{ 'companyDataRequired.header' | translate }}
        </h1>
      </div>
      <app-company-data-required />
    </div>
  </div>
}

<ng-container *ngIf="hasAccess; else accessDenied">
	<router-outlet></router-outlet>
</ng-container>
<ng-template #accessDenied>
	<app-access-denied></app-access-denied>
</ng-template>
